import type { RootState } from 'APP/Store/CreateStore'

export const selectPractitionerId = (state: RootState) => state.videoSession.practitionerId
export const selectKeepAliveIntervalId = (state: RootState) =>
  state.videoSession.keepAliveIntervalId
export const selectVideoKeepAliveEpisodeId = (state: RootState) =>
  state.videoSession.episodeId ?? state.videoSession.lastVideoCall.episodeId
export const selectVideoCallAcceptedAt = (state: RootState) => state.videoSession.lastCallAcceptedAt
